module.exports = __webpack_public_path__ + "img/cp6-5.82420629.jpg";